import { debounce } from 'es-toolkit';
import { ComponentProps } from 'react';

import { Input } from '../ui/input';
import { cn } from '../ui/utils';

export const INPUT_DELAY = 250;

export interface DebouncedSearchProps extends Omit<ComponentProps<typeof Input>, 'onChange'> {
  delay?: number;
  onChange: (term: string) => void;
}

export function DebouncedSearch({
  className,
  defaultValue,
  delay = INPUT_DELAY,
  onChange,
  placeholder = 'Search',
  ...props
}: DebouncedSearchProps) {
  const debouncedSetFilter = debounce((value) => {
    onChange(value);
  }, delay);

  return (
    <Input
      className={cn('w-sm', className)}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={(e) => debouncedSetFilter(e.target.value)}
      {...props}
    />
  );
}
